import { render, staticRenderFns } from "./ReviewDependents.vue?vue&type=template&id=71c30702&scoped=true"
import script from "./ReviewDependents.vue?vue&type=script&lang=ts"
export * from "./ReviewDependents.vue?vue&type=script&lang=ts"
import style0 from "./ReviewDependents.vue?vue&type=style&index=0&id=71c30702&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c30702",
  null
  
)

export default component.exports